import { render, staticRenderFns } from "./FeiiplatOauth.vue?vue&type=template&id=527275bb&scoped=true"
import script from "./FeiiplatOauth.vue?vue&type=script&lang=js"
export * from "./FeiiplatOauth.vue?vue&type=script&lang=js"
import style0 from "./FeiiplatOauth.vue?vue&type=style&index=0&id=527275bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527275bb",
  null
  
)

export default component.exports